/**
 * Primary UI component for Form Sections
 */

import { Button, cn, tv } from "@heroui/react";
import { IconDeviceFloppy } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";

export interface FormControlProps {
    title?: string;
    saveLabel: string;
    saveIcon?: ReactNode;
    resetLabel: string;
    onReset: () => void;
    onSave: () => void;
    isLoading?: boolean;
    isDisabled?: boolean;
    className?: string;
}

const formControl = tv({
    slots: {
        base: "sticky flex items-center justify-end gap-3 px-4 z-50 transition-all border-divider bottom-0 border-t bg-white h-24",
        title: "mr-auto",
    },
});

export const FormControl: FC<FormControlProps> = ({
    title,
    saveLabel,
    saveIcon,
    resetLabel,
    onReset,
    onSave,
    isDisabled,
    isLoading,
    className,
    ...props
}) => {
    const v = formControl(props);

    return (
        <div className={cn(v.base(), className)}>
            {title && <div className={v.title()}>{title}</div>}
            <Button
                variant="bordered"
                onPress={onReset}
                isDisabled={isDisabled}
            >
                {resetLabel}
            </Button>
            <Button
                color="primary"
                onPress={onSave}
                isDisabled={isDisabled}
                isLoading={isLoading}
                startContent={
                    saveIcon || <IconDeviceFloppy stroke={1.5} size={20} />
                }
            >
                {saveLabel}
            </Button>
        </div>
    );
};
